/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateBatchRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  createBatchRequest: components.CreateBatchRequest;
};

/** @internal */
export const CreateBatchRequest$inboundSchema: z.ZodType<
  CreateBatchRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  CreateBatchRequest: components.CreateBatchRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CreateBatchRequest": "createBatchRequest",
  });
});
/** @internal */
export type CreateBatchRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  CreateBatchRequest: components.CreateBatchRequest$Outbound;
};

/** @internal */
export const CreateBatchRequest$outboundSchema: z.ZodType<
  CreateBatchRequest$Outbound,
  z.ZodTypeDef,
  CreateBatchRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  createBatchRequest: components.CreateBatchRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    createBatchRequest: "CreateBatchRequest",
  });
});

export function createBatchRequestToJSON(
  createBatchRequest: CreateBatchRequest,
): string {
  return JSON.stringify(
    CreateBatchRequest$outboundSchema.parse(createBatchRequest),
  );
}
export function createBatchRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateBatchRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateBatchRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateBatchRequest' from JSON`,
  );
}
